import R from 'ramda';
import React, { Component } from 'react';
import { Row, Col, FormGroup, FormControl, Radio } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import getContent from '../ContractBlock/Contents/Contribution';
import { ContributionServices } from '../../constants';
import { getWorkTypeNameById, getMemberNameByUserId } from '../../utils';
import Select from '../Select';
import ChangeRequestsView from '../Deals/DealEditPages/ChangeRequestsView';

export default class Contribution extends Component {
  constructor(props) {
    super(props);
    this.state = { adjust: undefined, changes: {} };
  }

  options = () => ({
    other: this.state.changes.other,
    field1: this.state.changes.field1,
    field2: this.state.changes.field2,
    contributor: this.state.changes.contributor,
  });

  componentDidMount() {
    if (this.props.dealBlocks) {
      this.getBlockChanges(this.props.dealBlocks);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dealBlocks) {
      this.getBlockChanges(nextProps.dealBlocks);
    }
  }

  getBlockChanges(dealBlocks) {
    const block = R.find(R.propEq('id', this.props.block.id))(dealBlocks);
    if (block) {
      this.setState({
        changes: block.changes || {},
        adjust: block.accept ? !block.accept : block.changes ? true : undefined,
      });
    }
  }

  handleAdjust(adjust) {
    this.setState({ adjust });
    if (!adjust) {
      this.props.removeBlockChanges(this.props.block.id);
    }
  }

  handleContent(e, field) {
    const options = this.options();

    if (field === 'field1') {
      if (e.target.value === 'other') {
        options.other = true;
      } else if (e.target.value !== '') {
        options.other = false;
      }
      options.field1 = e.target.value;
    } else if (field === 'contributor') {
      options.contributor = e.target.value;
    }

    this.props.setBlockChanges({
      id: this.props.block.id,
      options,
      ...getContent(options),
    });
  }

  handleOtherContent(e) {
    const options = this.options();

    options.field2 = e.target.value;
    this.props.setBlockChanges({
      id: this.props.block.id,
      options,
      ...getContent(options),
    });
  }

  getContributions() {
    const { work, workTypes } = this.props;
    const typeName = getWorkTypeNameById(work.type, workTypes);

    return ContributionServices[typeName];
  }

  renderOriginal() {
    const { members, work, contributor } = this.props;
    let content = '';
    let ownerships = work.work_ownership_info || [];

    if (contributor) {
      let contributorName = getMemberNameByUserId(contributor, members);
      const ownership = R.find(R.propEq('user', parseInt(contributor, 10)))(
        ownerships
      );

      if (ownership) {
        if (ownership.use_company_name && ownership.company_name) {
          contributorName =
            contributorName + ' (' + ownership.company_name + ')';
        }
      }
      content = contributorName + ', ';
    }

    if (this.props.other === true) {
      content += this.props.field2;
    } else {
      content += this.props.field1;
    }

    return content;
  }

  renderAdjust() {
    const { adjust, changes } = this.state;
    const contributions = this.getContributions();

    if (adjust === true) {
      return (
        <div className="inner-content">
          <p className="question">
            Which collaborator is the Contributor (non-owner) to this work?
          </p>
          <FormGroup>
            <Select
              className="form-control"
              value={changes.contributor}
              onChange={(e) => this.handleContent(e, 'contributor')}
            >
              <option value="">Please select</option>
              {this.props.dealUsers.map((dealUser, i) => {
                if (dealUser.type === 'member') {
                  let userName = getMemberNameByUserId(
                    dealUser.user,
                    this.props.members
                  );
                  const ownerships = this.props.work.work_ownership_info || [];
                  const ownership = R.find(R.propEq('user', dealUser.user))(
                    ownerships
                  );

                  if (ownership) {
                    if (ownership.use_company_name && ownership.company_name) {
                      userName = userName + ' (' + ownership.company_name + ')';
                    }
                  }
                  return (
                    <option key={i} value={dealUser.user}>
                      {userName}
                    </option>
                  );
                }

                return null;
              })}
            </Select>
          </FormGroup>
          <p className="question">
            What was this Contributor's contribution to the work?
          </p>
          <FormGroup>
            <Select
              className="form-control"
              value={changes.field1}
              onChange={(e) => this.handleContent(e, 'field1')}
            >
              <option value="">Please select</option>
              {contributions.map((contribution, i) => (
                <option key={i}>{contribution}</option>
              ))}
              <option value="other">other</option>
            </Select>
          </FormGroup>
          {changes.other ? (
            <FormGroup className="answer">
              <FormControl
                type="text"
                placeholder="Please type text here"
                value={changes.field2}
                onChange={(e) => this.handleOtherContent(e)}
              />
            </FormGroup>
          ) : null}
        </div>
      );
    } else {
      return null;
    }
  }

  renderChangeRequest(changeRequest) {
    const { members, work } = this.props;
    let content = '';
    let ownerships = work.work_ownership_info || [];

    if (changeRequest.changes.contributor) {
      let contributorName = getMemberNameByUserId(
        changeRequest.changes.contributor,
        members
      );
      const ownership = R.find(
        R.propEq('user', parseInt(changeRequest.changes.contributor, 10))
      )(ownerships);

      if (ownership) {
        if (ownership.use_company_name && ownership.company_name) {
          contributorName =
            contributorName + ' (' + ownership.company_name + ')';
        }
      }
      content = contributorName + ', ';
    }

    if (changeRequest.changes.other === true) {
      content += changeRequest.changes.field2;
    } else {
      content += changeRequest.changes.field1;
    }

    return content;
  }

  renderChangeRequests() {
    return (
      <ChangeRequestsView
        changeRequests={this.props.changeRequests}
        renderChangeRequest={(changeRequest) =>
          this.renderChangeRequest(changeRequest)
        }
      />
    );
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>
              <p className="question">
                Who was the Contributor (non-owner) to this work and what was
                their contribution?
              </p>
              <FormGroup className="answer">
                <Radio
                  name="contribution-adjust"
                  checked={this.state.adjust === false}
                  readOnly
                  onClick={(e) => this.handleAdjust(false)}
                >
                  {this.props.userInfo.same
                    ? `Keep my original proposal: `
                    : `Accept ${this.props.userInfo.name} 's proposed terms: `}
                  {this.renderOriginal()}
                </Radio>
                <hr />
                <Radio
                  name="contribution-adjust"
                  checked={this.state.adjust === true}
                  readOnly
                  onClick={(e) => this.handleAdjust(true)}
                >
                  {this.props.userInfo.same
                    ? `Change my proposal:`
                    : `Suggest an alternative:`}
                </Radio>
                {this.renderAdjust()}
              </FormGroup>
              {this.props.renderAccepts()}
              {this.renderChangeRequests()}
            </Col>
          )}
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>{this.props.children}</Col>
          )}

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  The "contribution" is a description of the type of work that
                  will be done (e.g. production services, graphic design,
                  editing services). Defining this clears up any confusion about
                  what work is considered to have been done on a "work for hire"
                  basis.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/DealContractBlock/Contribution.jsx